/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-prototype-builtins */
import { Tag, Typography } from "antd";
import ProductParameter from "components/_storybooks/ProductParameter";
import { PRODUCT_INPUT_TYPE } from "config/constants";
import { useGetProdAttribute } from "hooks/attribute";
import { useGetManufacturers } from "hooks/manufacturer/manufacturer";
import { useGetProducts } from "hooks/product/product";
import useDebounce from "hooks/useDebounce";
import { useWarehouse } from "hooks/warehouse";
import { t } from "i18next";
import { isNil, omit } from "lodash";
import { SEARCH_TYPE, SELLING_STATUS } from "pages/App/Product/constants";
import { FilterStatus, FilterVatPercent } from "pages/App/Product/Product/List/components/FilterProduct";
import { useEffect, useState } from "react";
import { formatCurrency } from "utils/helperFuncs";
import { FilterAttributes, FilterLevelPrice, FilterManufacture, FilterRealStocks } from "../FilterProduct";

const usePopupShowAllProduct = ({ data, index }) => {
  const [searchType, setSearchType] = useState(SEARCH_TYPE.SINGLE);
  const [itemsSearchBulk, setItemsSearchBulk] = useState([]);

  const listProductIds = data?.conditionPromotionProducts?.map((item) => item?.product?.id);
  const { warehouses: listWarehouse, loadingWarehouses } = useWarehouse();
  const listCate = data?.conditionPromotionProducts?.map((item) => item?.product?.categoryID);
  const [visible, setVisible] = useState(false);
  const showModal = () => {
    setVisible(true);
  };
  const handleCancel = () => {
    setVisible(false);
  };

  function filterRealStocks(values) {
    //first make it unique array then filter it has own property range
    const realStocks = [
      ...new Map(
        [...(params.filters?.realStocks ? params.filters.realStocks : []), values].map((item) => [
          item.warehouseID,
          item,
        ])
      ).values(),
    ].filter((item) => item.hasOwnProperty("range") && item.range);

    setParams({
      ...params,
      filters: {
        ...params.filters,
        realStocks: realStocks.length > 0 ? realStocks : undefined,
      },
      pagination: {
        ...params.pagination,
        offset: 0,
      },
    });
  }

  const renderChildrenInStock = (warehouses) => {
    const findDefaultValue = (realStocks, value) => {
      if (realStocks && value) {
        return realStocks.find((item) => item.warehouseID === value);
      } else return undefined;
    };
    return warehouses?.map((warehouse, index) => ({
      title: (
        <div className="title-table" style={{ textTransform: "uppercase" }}>
          {warehouse.name}
        </div>
      ),
      key: index,
      width: 100,
      align: "center",
      editable: "false",
      render: (_, record) =>
        record?.stocks?.filter((stock) => stock?.warehouse?.id === warehouse?.id)[0]?.quantity || "- -",
      filterDropdown: (
        <FilterRealStocks
          onFilter={filterRealStocks}
          warehouseID={warehouse.id}
          defaultValue={findDefaultValue(params.filters.realStocks, warehouse.id)}
        />
      ),
    }));
  };

  const { data: prodAtt } = useGetProdAttribute(listCate);
  const { dataManufactures, loadingManufactures } = useGetManufacturers();

  const filterProductAttributes = (values) => {
    const attributeValues = [
      ...new Map(
        [...(params.filters?.attributeValues ? params.filters.attributeValues : []), values].map((item) => [
          item.attributeID,
          item,
        ])
      ).values(),
    ].filter((item) => item.valueIDs?.length > 0);

    setParams({
      ...params,
      filters: {
        ...params.filters,
        attributeValues: attributeValues.length > 0 ? attributeValues : undefined,
      },
      pagination: {
        ...params.pagination,
        offset: 0,
      },
    });
  };

  const renderProductAttributes = (attributes = []) => {
    const findDefaultValue = (attributes, value) => {
      if (attributes && value) {
        return attributes.find((item) => item.attributeID === value);
      } else return undefined;
    };
    if (attributes?.length > 0)
      return attributes?.map((attribute) => ({
        title: <div style={{ textTransform: " uppercase" }}>{attribute.name}</div>,
        key: attribute.id,
        width: 125,
        align: "center",
        editable: "false",
        filterDropdown: (
          <FilterAttributes
            attributeId={attribute.id}
            attributeList={attribute.values}
            defaultValue={findDefaultValue(params.filters.attributeValues, attribute.id)?.valueIDs}
            onFilter={filterProductAttributes}
          />
        ),
        render: (_, record) => {
          const prodAtt = record?.fullAttributeValues?.find((item) => item.attributeID === attribute.id);
          if (prodAtt) {
            return (
              <span>{prodAtt?.attributeValues?.map((attributeValue) => attributeValue.value).join(", ") || "- -"}</span>
            );
          }
          return "- -";
        },
      }));
    return [];
  };

  function filterProductPrices(values, key) {
    const newValue = values?.isSpecified === undefined ? null : values;

    const newParams = {
      ...params,
      filters: {
        ...params.filters,
        [`${key}`]: newValue,
      },
      pagination: {
        ...params.pagination,
        offset: 0,
      },
    };

    setParams(newParams);
  }

  const defaultParams = {
    filters: {
      query: "",
      categoryIDs: undefined,
      manufacturerIDs: undefined,
      priceLevel1: undefined,
      priceLevel2: undefined,
      priceLevel3: undefined,
      price: undefined,
      realStocks: undefined,
      vat: undefined,
      vatPercent: undefined,
      attributeValues: undefined,
      productType: undefined,
      ids: listProductIds,
    },
    pagination: {
      limit: 10,
      offset: 0,
    },
  };

  const [params, setParams] = useState(defaultParams);
  const { loading, data: productData, paginationData } = useGetProducts(params);

  function filterProductExtra(values) {
    const newParams = {
      ...params,
      filters: {
        ...params.filters,
        ...values,
      },
      pagination: {
        ...params.pagination,
        offset: 0,
      },
    };

    setParams(newParams);
  }

  const columns = [
    {
      title: "Thông số",
      render: (_, record, index) => <ProductParameter parameter={record} />,
      width: 300,
      align: "left",
    },
    {
      title: t("product.tableTitle.brand"),
      render: (_, record) => <Typography.Text>{record?.manufacturer?.name}</Typography.Text>,
      filterDropdown: (
        <FilterManufacture
          dataManufactures={dataManufactures}
          onFilter={filterProductExtra}
          defaultValue={params?.filters?.manufacturerIDs}
        />
      ),
    },
    {
      title: t("product.tableTitle.warranty"),
      render: (_, record) => (
        <Typography.Text>
          <div>{record?.warranty ? `${record?.warranty} ${t("common.month")}` : "- -"}</div>
        </Typography.Text>
      ),
    },
    ...renderProductAttributes(prodAtt),
    {
      title: "LOẠI % VAT",
      dataIndex: "vatPercent",
      align: "center",
      render: (_, record) => {
        return <div>{record.vatPercent >= 0 ? `${record.vatPercent}%` : "KCT"}</div>;
      },
      width: 150,
      editable: "true",
      inputType: PRODUCT_INPUT_TYPE.VAT_PERCENT,
      filterDropdown: <FilterVatPercent onFilter={filterProductExtra} defaultValue={params.filters.vatPercent} />,
    },
    {
      title: "GIÁ CÓ VAT",
      render: (_, record) => {
        return (
          <div>
            {record?.productPrices?.priceVat ? formatCurrency(record?.productPrices?.priceVat) : formatCurrency(0)}
          </div>
        );
      },
      fixed: "center",
      filterDropdown: (
        <FilterLevelPrice
          onFilter={(priceLevel) => {
            filterProductPrices(priceLevel, "priceVat");
          }}
          defaultValue={params.filters.priceVat}
        />
      ),
    },
    {
      title: t("cart.inStockColumn"),
      children: renderChildrenInStock(listWarehouse),
    },
    {
      title: t("product.tableTitle.status"),
      dataIndex: "isActive",
      align: "center",
      editable: "false",
      fixed: "right",
      filterDropdown: <FilterStatus onFilter={filterProductExtra} defaultValue={params?.filters?.sellingStatuses} />,
      render: (_, record) => {
        return (
          <div>
            {record?.sellingStatus === SELLING_STATUS.AVAILABLE && (
              <Tag className="custom-tag-status-product-available">Đang kinh doanh</Tag>
            )}
            {record?.sellingStatus === SELLING_STATUS.UNAVAILABLE && (
              <Tag className="custom-tag-status-product-unavailable">Ngừng kinh doanh</Tag>
            )}
            {record?.sellingStatus === SELLING_STATUS.CONTACT && (
              <Tag className="custom-tag-status-product-contact">Liên hệ</Tag>
            )}
          </div>
        );
      },
    },
  ];

  const handleChangeTable = (pagination) => {
    const { current, pageSize } = pagination;
    let newParams = {
      ...params,
      pagination: { ...params?.pagination, offset: (current - 1) * pageSize },
      sorts: params?.sorts,
    };
    setParams(newParams);
  };

  const [searchTerm, setSearchTerm] = useState(null);
  const debouncedValue = useDebounce(searchTerm);

  const onSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleRemoveFilterTag = (key) => {
    setParams({
      pagination: { offset: 0, limit: 10 },
      filters: {
        ...omit({ ...params.filters }, [`${key}`]),
      },
      sort: params.sort,
      activeKey: params.activeKey,
    });
  };

  function handleSearchBulkProduct(uniqueTags) {
    setParams((prev) => ({
      ...prev,
      filters: {
        ...prev.filters,
        productCodes: uniqueTags,
      },
      pagination: {
        ...prev.pagination,
        offset: 0,
      },
    }));
  }
  const handleChangeSelectSearch = (value) => {
    const joined = value.join(" ");
    const newTags = joined
      .split(/[, ]+/)
      .map((t) => t.trim())
      .filter(Boolean);
    const uniqueTags = Array.from(new Set(newTags));
    setItemsSearchBulk(uniqueTags);
    handleSearchBulkProduct(uniqueTags);
  };

  const handleSelectSearchType = (value) => {
    setSearchType(value);
    setItemsSearchBulk([]);
    if (searchType === SEARCH_TYPE.SINGLE) {
      setSearchTerm("");
    } else {
      handleSearchBulkProduct([]);
    }
  };

  useEffect(() => {
    if (!isNil(debouncedValue)) {
      const newParams = {
        ...params,
        filters: { ...params?.filters, query: debouncedValue },
        pagination: {
          offset: 0,
          limit: 10,
        },
      };
      setParams(newParams);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedValue]);

  useEffect(() => {
    setParams(defaultParams);
  }, [JSON.stringify(visible)]);

  return {
    loading,
    columns,
    productData,
    paginationData,
    handleChangeTable,
    onSearch,
    params,
    handleRemoveFilterTag,
    setParams,
    prodAtt,
    listWarehouse,
    dataManufactures,
    loadingManufactures,
    loadingWarehouses,
    showModal,
    handleCancel,
    visible,
    searchType,
    itemsSearchBulk,
    handleChangeSelectSearch,
    handleSelectSearchType,
  };
};

export default usePopupShowAllProduct;
